import React from 'react';
import { CheckIcon } from 'lucide-react';
import { inclusions } from '../data/content';
export function Inclusions() {
  return <section aria-labelledby="inclusions-title" className="bg-paper" data-id="element-81" data-mp="3bua6prhp0f2b">
      <div className="mx-auto grid max-w-6xl gap-4 px-5 py-12 lg:grid-cols-[0.8fr_1.2fr] lg:py-24" data-id="element-82" data-mp="2xu7rkd0rrzqr">
        <div data-id="element-83" data-mp="31urslrogrni6">
          <h2 id="inclusions-title" className="font-display text-[2rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-84" data-mp="31wciv53qwka8">
            Todo esto encontrarás dentro
          </h2>
          <div className="mt-5 inline-flex items-baseline gap-3 rounded-2xl border-2 border-ink bg-kraft px-5 py-3 sm:mt-8 sm:px-6 sm:py-4" data-id="element-85" data-mp="3uki9g8hhd3hz">
            <span className="font-display text-5xl font-black" data-id="element-86" data-mp="3gsbpscf4ceds">+160</span>
            <span className="max-w-[9rem] text-sm font-medium leading-tight" data-id="element-87" data-mp="3kt42jfn791et">páginas imprimibles y en PDF</span>
          </div>
        </div>
        <ul className="grid gap-x-8 sm:grid-cols-2" data-id="element-88" data-mp="cc98mpodqrcv">
          {inclusions.map(item => <li key={item} className="flex items-start gap-3 border-b border-dashed border-kraft-dark/40 py-3 sm:py-4" data-id="element-89" data-mp="h6n6cyqilakp">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-rust-dark" strokeWidth={3} aria-hidden="true" data-id="element-90" data-mp="6597jlk01whv" />
              <span className="font-medium" data-id="element-91" data-mp="fx58r5hdu2qb">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}